import { get, trim, some, toLower } from "lodash"
import { DEFAULT_CURRENCY } from "helpers/formatters/numbers"

function isSupportedCurrency(currency, modelCurrencies) {
  return !currency || currency === DEFAULT_CURRENCY || get(modelCurrencies, currency, false)
}

function getFxHedgeMessage(currency, modelFactors = {}, fxHedgeEnabled = false) {
  let fxHedgeMessage
  if (!fxHedgeEnabled) {
    return fxHedgeMessage
  }

  const factors = Object.values(modelFactors)

  if (!currency) {
    currency = DEFAULT_CURRENCY
  }

  const hasCurrencyFactors = some(factors, factor => toLower(factor.category) === "currency")

  if (!hasCurrencyFactors) {
    fxHedgeMessage = "FX hedge will be disabled, as the risk model does not include currency factors."
    return fxHedgeMessage
  }

  const hasHedgeCurrencyFactor = some(factors, factor => toLower(factor.category) === "currency" && factor.id === currency)

  if (!hasHedgeCurrencyFactor) {
    fxHedgeMessage = `FX hedge will be disabled, as the risk model does not include the portfolio base currency (${currency}).`
  }

  return fxHedgeMessage
}

function getCurrencyAndFxHedgeMessage(currencyMessage = "", fxHedgeMessage = "") {
  if (!currencyMessage && !fxHedgeMessage) {
    return
  }

  return trim(`${currencyMessage} ${fxHedgeMessage}`)
}

export function unsupportedCurrencyWarning(modelCurrencies, accountCurrency, resourceCurrency, fxHedgeEnabled = false, modelFactors) {
  const isResourceCurrencySupported = isSupportedCurrency(resourceCurrency, modelCurrencies)
  if (resourceCurrency && isResourceCurrencySupported) {
    return getFxHedgeMessage(resourceCurrency, modelFactors, fxHedgeEnabled)
  }

  const fxHedgeMessagePart = fxHedgeEnabled ? " and FX hedge are" : " is"

  let currencyMessage
  let finalCurrency
  let fxHedgeMessage

  const isAccountCurrencySupported = isSupportedCurrency(accountCurrency, modelCurrencies)
  if (!isResourceCurrencySupported && accountCurrency && isAccountCurrencySupported) {
    currencyMessage = `${resourceCurrency} is not supported by this model; currency${fxHedgeMessagePart} adjusted to the account's default (${accountCurrency}).`
    finalCurrency = accountCurrency
  } else if (!isResourceCurrencySupported && !isAccountCurrencySupported) {
    currencyMessage = `${resourceCurrency} is not supported by this model; currency${fxHedgeMessagePart} adjusted to the model's default.`
    finalCurrency = DEFAULT_CURRENCY
  } else if (!isAccountCurrencySupported) {
    currencyMessage = `${accountCurrency} is not supported by this model; currency${fxHedgeMessagePart} adjusted to the model's default.`
    finalCurrency = DEFAULT_CURRENCY
  }

  if (fxHedgeEnabled) {
    fxHedgeMessage = getFxHedgeMessage(finalCurrency, modelFactors, fxHedgeEnabled)
  }

  return getCurrencyAndFxHedgeMessage(currencyMessage, fxHedgeMessage)
}
